module.exports = __webpack_public_path__ + "static/mennica-766697ac3b1768b82885993d6cc4726f.jpg";